import {
  Component,
  ViewChild,
  Injector,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import {
  StaffsServiceProxy,
  StaffSubordinatesHierarchiesServiceProxy,
  StaffUserLookupTableDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent } from 'primeng/public_api';
@Component({
  selector: 'staffUserLookupTableModal',
  styleUrls: ['./staff-user-lookup-table-modal.component.less'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './staff-user-lookup-table-modal.component.html',
})
export class StaffUserLookupTableModalComponent extends AppComponentBase {
  @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
  @ViewChild('dataTable', { static: true }) dataTable: Table;
  @ViewChild('paginator', { static: true }) paginator: Paginator;

  filterText = '';
  id: number;
  selected;

  @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
  active = false;
  saving = false;

  ownDetailsEdit: Boolean = false;
  subordinatedStaffId: number;

  constructor(
    injector: Injector,
    private _staffsServiceProxy: StaffsServiceProxy,
    private _staffSubordinatesHierarchiesProxy: StaffSubordinatesHierarchiesServiceProxy
  ) {
    super(injector);
  }

  show(): void {
    this.active = true;
    this.paginator.rows = 5;
    this.getAll();
    this.modal.show();
  }

  getAll(event?: LazyLoadEvent) {
    if (!this.active) {
      return;
    }

    if (this.primengTableHelper.shouldResetPaging(event)) {
      this.paginator.changePage(0);
      return;
    }

    this.primengTableHelper.showLoadingIndicator();

    if (this.ownDetailsEdit) {
      this._staffSubordinatesHierarchiesProxy
        .getAllStaffAllowedToBeMySuperiors(
          this.filterText,
          this.primengTableHelper.getSorting(this.dataTable),
          this.primengTableHelper.getSkipCount(this.paginator, event),
          this.primengTableHelper.getMaxResultCount(this.paginator, event)
        )
        .subscribe((result) => {
          this.primengTableHelper.totalRecordsCount = result.totalCount;
          this.primengTableHelper.records = result.items;
          this.primengTableHelper.hideLoadingIndicator();
        });
    } else {
      this._staffSubordinatesHierarchiesProxy
        .getAllStaffAllowedToBeSuperiors(
          this.filterText,
          this.subordinatedStaffId,
          this.id == null,
          this.primengTableHelper.getSorting(this.dataTable),
          this.primengTableHelper.getSkipCount(this.paginator, event),
          this.primengTableHelper.getMaxResultCount(this.paginator, event)
        )
        .subscribe((result) => {
          this.primengTableHelper.totalRecordsCount = result.totalCount;
          this.primengTableHelper.records = result.items;
          this.primengTableHelper.hideLoadingIndicator();
        });

    }
  }

  reloadPage(): void {
    this.paginator.changePage(this.paginator.getPage());
  }

  setAndSave(user) {
    this.id = user.id;
    this.selected = user;

    this.active = false;
    this.modal.hide();
    this.modalSave.emit(null);
  }

  close(): void {
    this.active = false;
    this.modal.hide();
    this.modalSave.emit(null);
  }
}
